import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { DocketService } from 'src/app/api/core/docket/docket.service';
import { BffService } from 'src/app/api/utils/comms/bff/bff.service';
import { WatcherService } from 'src/app/api/utils/watcher/watcher.service';
import { Order } from 'src/app/models/order.model';
import { CommsService } from '../../../../utils/comms/comms.service';
import { APP_DOCKET_DISPLAY_UPDATE } from '../../../../utils/watcher/watcher-event';
import { AuthService } from '../../../auth/auth.service';
import { CoreService } from '../../../core/core.service';
import { FeatureFlagList, FeatureFlagsService } from '../../../settings/feature-flags.service';
import { HandleFailedDispatchService } from '../handle.failed.dispatch.service';
import { BffDispatchRequest, OrderDispatcherService } from '../order-dispatcher/order-dispatcher.service';

@Injectable({
  providedIn: 'root',
})
export class DispatchBumpService extends OrderDispatcherService {
  constructor(
    public watcher: WatcherService,
    public comms: CommsService,
    public auth: AuthService,
    public core: CoreService,
    public docketService: DocketService,
    public handleFailedDispatchService: HandleFailedDispatchService,
    public featureFlagsService: FeatureFlagsService,
    public bffService: BffService,
  ) {
    super(core, docketService, auth, bffService);
  }

  /**
   * Send a request to the server to update the bumps status of an order
   * @param orderId - The order of the id to be updated
   * @param bumpStatus - The bump status to set. Valid values are "new" and "bumped".
   */
  async updateDocketBumpStatus(orderId: string, bumpStatus: string): Promise<any> {
    return new Promise(resolve => {
      const order: Order = this.docketService.getOrderById(orderId);
      if (order) {
        order.bump_status = bumpStatus;

        // setup object to send - with bump screen ID, return order obj :NO, & ETA array
        let sendObj: any = {
          bump_screen_id: this.auth.Active_bump_screen.id,
          return_orders: true, // force it false for now
          orders: [],
        };

        // set the type
        if (order.type == 'batch_order') {
          sendObj.type = order.type;
          sendObj.batch_id = order.id;
          sendObj.bump_status = bumpStatus;
        } else {
          // create the order request
          sendObj.orders.push({ id: order.id, bump_status: bumpStatus });
        }

        // force a list update FIRST
        this.watcher.broadcast(APP_DOCKET_DISPLAY_UPDATE, 'updateDocketBumpStatus');

        let bumpResponse: Observable<any> = this.updateOrder_Drupal(sendObj);

        // Separate BFF Call
        if (this.featureFlagsService.isFeatureFlagEnabled(FeatureFlagList.BFF)) {
          this.dispatchDocket([orderId], BffDispatchRequest.BUMP_STATUS).subscribe(
            bffPayload => {
              console.log('BFF BUMP Success:', bffPayload);
              // trackevents
            },
            bffFailed => {
              console.log('BFF BUMP Failed:', bffFailed);
              // trackevents
            },
          );
        }

        bumpResponse.pipe(take(1)).subscribe(
          payload => {
            // block propagation of response if user already logged out
            if (!this.auth.Logged_in) {
              resolve(false);
              return;
            }

            if (payload && payload.success) {
              if (payload.orders) {
                this.docketService.updateOrders(payload.orders, false);
              }
              resolve(true);
            } else {
              // show some error
              this.handleFailedDispatchService.handleFailedUpdateRequest(order, 'bump');
              resolve(false);
            }
          },
          fail => {
            // block propagation of response if user already logged out
            if (!this.auth.Logged_in) {
              resolve(false);
              return;
            }

            // show some error
            this.handleFailedDispatchService.handleFailedUpdateRequest(order, 'bump');
            resolve(false);
          },
        );
      } else {
        // order not found
        resolve(false);
      }
    });
  }

  updateOrder_Drupal(sendObj: any): Observable<any> {
    return new Observable(subscriber => {
      const header = new HttpHeaders(this.auth.headerData);

      // force 20 seconds timeout for send bump status
      this.comms.post(
        this.core.Active_server.url + 'api/bump/orders/v3',
        sendObj,
        {
          headers: header,
        },
        payload => {
          subscriber.next(payload);
          subscriber.complete();
        },
        err => {
          subscriber.error(err);
          subscriber.complete();
        },
        this.UPDATE_TIMEOUT,
      );
    });
  }
}
